import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
import { createHelpcenterContactApi, helpcenterContactApiRelativePath } from './index';
export var createHelpcenterContactApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createHelpcenterContactApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetContactSettings: function (dto) {
            return createFakeGetResponder(fakeHttp, helpcenterContactApiRelativePath + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdateContactSettings: function (dto) {
            return createFakePutResponder(fakeHttp, helpcenterContactApiRelativePath + "/" + dto.locale)(dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map